import { configureStore } from "@reduxjs/toolkit";
import knightReducer from "./slices/knight-slice";
import farmingReducer from "./slices/farming-slice";
import armouryReducer from "./slices/armoury-slice";
import statisticSlice from "./slices/statistic-slice";
import profileReducer from "./slices/profile-slice";
import accountReducer from "./slices/account/account-slice";
import balanceReducer from "./slices/other/balance-slice";

export default configureStore({
  reducer: {
    knightSlice: knightReducer,
    farmingSlice: farmingReducer,
    armourySlice: armouryReducer,
    statisticSlice: statisticSlice,
    profileSlice: profileReducer,
    accountSlice: accountReducer,
    balanceSlice: balanceReducer,
  },
  devTools: process.env.NODE_ENV === "development",
});
